import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'rate-renderer-cell',
    templateUrl: './rate-renderer.component.html',
    standalone: false
})
export class RateRendererComponent implements ICellRendererAngularComp {
    public rate: number;

    initilize(params: ICellRendererParams) {
        this.rate = params.getValue();
    }

    // called on init
    agInit(params: any): void {
        this.initilize(params);
    }

    // called when the cell is refreshed
    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
